import React from "react";
import { Flex } from "rebass/styled-components";
import styled from "styled-components";
import { PaddedWrapper } from "../../../../Components/Wrappers";
import { Owner } from "./Component/Owner";

export function Header({
  allstarUser,
  user,
  loading,
  followUnfollow,
  isDesktop,
}) {
  return (
    <StyledPaddedWrapper
      mt={[7, 7, 9, 9]}
      mb={[0, 0, 4, 4]}
      isDesktop={isDesktop}
    >
      <Viewport>
        <Owner
          flexBasis="100%"
          loading={loading}
          allstarUser={allstarUser}
          followUnfollow={followUnfollow}
          avatarImage={user?.avatarImage}
          displayName={user?.username ? user?.username : user?.displayName}
          username={user?.username}
          userRank={user?.userRank}
          followers={user?.followers?.followers}
          following={user?.followers?.following}
          userId={user?.userId}
          user={user}
          isOwnProfile={user?.isOwnProfile}
        />
      </Viewport>
    </StyledPaddedWrapper>
  );
}

const StyledPaddedWrapper = styled(PaddedWrapper)`
  width: 100%;
  padding-left: ${(props) => (props.isDesktop ? 30 : 140)}px;
  margin: auto;
  margin-top: 60px;

  @media (max-width: ${(props) => props.theme.breakpoints[3]}) {
    padding-left: ${(props) => (props.isDesktop ? 30 : 140)}px;
  }

  @media (max-width: ${(props) => props.theme.breakpoints[2]}) {
    padding-left: 40px;
    margin-top: 30px;
  }

  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    padding-left: 15px;
    margin-top: 30px;
  }
`;

const Viewport = styled(Flex)`
  overflow: hidden;
  position: relative;
  width: 100%;

  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    display: block;
  }
`;
